/** @jsxRuntime classic */
/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { Colors, Typography } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { COLOR_KEYS, MEDIA_MAX_WIDTH } from '../../../constants';
import { Plan, Props as PlanType } from './Plan';

type BackgroundColor =
  | typeof COLOR_KEYS.moss
  | typeof COLOR_KEYS.neutral800
  | typeof COLOR_KEYS.night
  | typeof COLOR_KEYS.zapier;

type Props = {
  plans: PlanType[];
  backgroundColor: BackgroundColor;
  title: string;
};

const Styles = labelStyles('PlanComparisonSection', {
  root: (backgroundColor: BackgroundColor) =>
    css({
      backgroundColor: Colors[backgroundColor],
      padding: '87px 22px',
      [MEDIA_MAX_WIDTH.large]: {
        padding: '60px 50px 48px 50px',
      },
      [MEDIA_MAX_WIDTH.small]: {
        padding: '73px 20px 83px 20px',
      },
    }),
  content: css({
    maxWidth: '1170px',
    margin: 'auto',
  }),
  title: css({
    ...Typography.pageHeader5,
    color: Colors.cream,
    textAlign: 'center',
    height: '100%',
    [MEDIA_MAX_WIDTH.small]: {
      ...Typography.pageHeader7,
    },
  }),
  plans: css({
    display: 'grid',
    marginTop: '83px',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridGap: '30px',

    [MEDIA_MAX_WIDTH.large]: {
      gridTemplateColumns: 'repeat(1, 1fr)',
      marginTop: '57px',
    },
    [MEDIA_MAX_WIDTH.small]: {
      gridGap: '20px',
      marginTop: '36px',
    },
  }),
});

export function PlanComparisonSection({
  plans = [],
  title,
  backgroundColor = COLOR_KEYS.zapier,
}: Props) {
  return (
    <div css={Styles.root(backgroundColor)}>
      <div css={Styles.content}>
        <h2 css={Styles.title}>{title}</h2>
        <div css={Styles.plans}>
          {plans.map((plan, index) => (
            <Plan key={`${plan.title}-${index}`} {...plan} />
          ))}
        </div>
      </div>
    </div>
  );
}
